import React from 'react';
import { PrimeIcons } from 'primereact/api';
import { classNames } from 'primereact/utils';
import { TICKET_TYPE_LABELS } from '../constants/ticketLabels';
import './TicketTypesLegend.scss';

const TYPE_ICONS: Record<string, string> = {
  bug: PrimeIcons.TIMES_CIRCLE,
  feature: PrimeIcons.STAR,
  modification: PrimeIcons.COG,
};

const TYPE_COLORS: Record<string, string> = {
  bug: 'var(--danger)',
  feature: 'var(--success)',
  modification: 'var(--info)',
};

const TYPE_DESCRIPTIONS: Record<string, string> = {
  bug: 'Reporta un problema o fallo en el sistema que necesita ser corregido.',
  feature: 'Solicita añadir algo nuevo que actualmente no existe en el sistema o extender la funcionalidad de algo que ya existe.',
  modification: 'Solicita cambiar o ajustar algo que ya existe en el sistema.',
};

export const TicketTypesLegend = () => {
  return (
    <div className='ticket-types-legend'>
      <h5 className='legend-title'>Tipos de tickets</h5>
      <div className='legend-items'>
        <div className='legend-item'>
          <i
            className={classNames('legend-icon', TYPE_ICONS.bug)}
            style={{ color: TYPE_COLORS.bug }}
          ></i>
          <div className='legend-content'>
            <span className='legend-label'>{TICKET_TYPE_LABELS.bug}</span>
            <span className='legend-description'>{TYPE_DESCRIPTIONS.bug}</span>
          </div>
        </div>
        <div className='legend-item'>
          <i
            className={classNames('legend-icon', TYPE_ICONS.feature)}
            style={{ color: TYPE_COLORS.feature }}
          ></i>
          <div className='legend-content'>
            <span className='legend-label'>{TICKET_TYPE_LABELS.feature}</span>
            <span className='legend-description'>{TYPE_DESCRIPTIONS.feature}</span>
          </div>
        </div>
        <div className='legend-item'>
          <i
            className={classNames('legend-icon', TYPE_ICONS.modification)}
            style={{ color: TYPE_COLORS.modification }}
          ></i>
          <div className='legend-content'>
            <span className='legend-label'>{TICKET_TYPE_LABELS.modification}</span>
            <span className='legend-description'>{TYPE_DESCRIPTIONS.modification}</span>
          </div>
        </div>
      </div>
    </div>
  );
};
